<template>
  <b-input-group class="">
    <b-button
      class="btn btn-outline-light border-radius border-radius-tr border-radius-br me-2"
      v-if="mostrarBotaoFiltro"
      @click="emitClickBotaoFiltro"
    >
      <span class="mdn-Icon-filtrar mdn-Icon--md"></span>
    </b-button>

    <b-form-input
      @input="emitFilterInputTextChange"
      v-model="inputText"
      class="border-radius-tl border-radius-bl"
      placeholder="Buscar por:"
    ></b-form-input>

    <b-input-group-append>
      <button 
        class="btn btn-search border-radius-tr border-radius-br"
        style="display: block; margin-left: -10px !important;"
        @click="emitFilterInputTextClick"
        v-if="mostrarBotaoLupa"
      >
        <span class="mdn-Icon-busca mdn-Icon--md"></span>
      </button>

    </b-input-group-append>

  </b-input-group>

</template>

<script>
export default {
  name: 'SGPFiltroInputBuscaComponent',

  props: {
    mostrarBotaoFiltro: {
      type: Boolean,
      required: false,
      default: false
    },

    mostrarInputFiltro: {
      type: Boolean,
      required: false,
      default: true
    },

    mostrarBotaoLupa: {
      type: Boolean,
      required: false,
      default: true
    }

  },

  data () {
    return {
      inputText: ''
    }
  },

  methods: {
    emitClickBotaoFiltro () {
      this.$emit('sgpFiltroInputBtnClick')
    },

    emitFilterInputTextChange () {
      this.$emit('sgpFiltroInputChange', this.inputText)
    },

    emitFilterInputTextClick () {
      this.$emit('sgpFiltroInputSearchBtnClick', this.inputText)
    }
  }
}
</script>